export default __webpack_public_path__ + "static/media/checklist-green.628582e7.svg";